import React from 'react';
import { Nav, Icon } from '@beisen/chaos-ui';
import BSNav from '../PageNav/Nav';
import SwitchView from '../PageNav/SwitchView';
import { isNotEmpty, inIframe } from '../util/check';
import {
    getQueryObject,
    genRightItemByExtensionNavConfig,
    getNavLeftExtension,
    getNavColorExtensionConfig,
    ifHidePopupNav,
    setBaseHeaderConfig,
    getEnv
} from '../util/helper';
class IndexNav extends React.Component {
    constructor(props) {
        super(props);
        this.popBack = this.popBack.bind(this);
    }

    componentDidMount() {
        if (this.props.isIndexPop && window.env.platform.iTalentIOS) {
            window.env.getJSBridge().then(() => {
                window.env.on(
                    { name: 'iTalentIOS_pop_indexview_close' },
                    () => {
                        window.env.trigger({
                            name: 'iTalentIOS_pop_indexview_cancel'
                        });
                        window.env.closePage();
                    }
                );
            });
        }
    }

    componentWillUnmount() {
        if (window.env.platform.iTalentIOS && window.env.platform.iTalentIOS) {
            window.env.off({ name: 'iTalentIOS_pop_indexview_close' });
        }
    }

    existNavView() {
        return isNotEmpty(this.props.indexData, ['NavView', 'cmp_data']);
    }

    navMode() {
        return (
            this.existNavView() && this.props.indexData.NavView.cmp_data.mode
        );
    }

    notShowCloseSys() {
        if (isNotEmpty(this.props.errors, ['code'])) {
            const code = this.props.errors.code;
            if (code == '403' || code == '404' || code == '500') {
                return true;
            }
        }
        return false;
    }

    getExtensionNavConfig() {
        const leftCb = getNavLeftExtension(this.props.indexData.NavView);
        const navColor = getNavColorExtensionConfig(
            this.props.indexData.NavView
        );
        let headerColor = {};
        navColor &&
            (headerColor = {
                color: navColor.color || '#6B7175',
                showBorder: true,
                bgColor: navColor.bgColor || '#fafafa',
                titleItem: { color: navColor.titleColor || '#3A4247' }
            });
        return { leftCb, headerColor };
    }

    popBack() {
        window.iTalentSDK.sendMessage({
            publishEvent: 'pop_indexview_cancel'
        });
    }

    // 1.有错误 title为空 2.有扩展导航模式 则显示url上标题 3.没有扩展导航模式 title为空 走center逻辑展示标题
    navTitle() {
        if (!this.navMode()) return '';
        const queryObj = getQueryObject();
        return queryObj.mtitle
            ? decodeURIComponent(queryObj.mtitle)
            : this.props.queryUrl.title || '';
    }

    navCenter() {
        const { NavView = {} } = this.props.indexData;
        if (this.navMode() || !NavView.sub_cmps) return null;

        const {
            actions,
            switchViewShowChange,
            viewActived,
            closePop
        } = this.props;
        let centerEl;
        if (NavView) {
            if (NavView.sub_cmps.length == 1) {
                centerEl = (
                    <span role="center">
                        {(NavView.biz_data[NavView.cmp_data.currentViewName] &&
                            NavView.biz_data[NavView.cmp_data.currentViewName]
                                .text) ||
                            ' '}
                    </span>
                );
            } else {
                centerEl = (
                    <SwitchView
                        role="center"
                        ref="DropDown"
                        {...NavView}
                        key={NavView.cmp_id}
                        actions={actions}
                        showChange={switchViewShowChange}
                        viewActived={viewActived}
                        repellentHandler={closePop}
                    />
                );
            }
            return centerEl;
        }
        return null;
    }

    navRight() {
        return (
            <span role="right">
                {genRightItemByExtensionNavConfig(
                    this.props.indexData.NavView,
                    'index'
                ) || <br />}{' '}
            </span>
        );
    }

    navAttr() {
        const { indexData, isClick } = this.props;
        let attr = {};
        if (indexData.status == 'loading' && !isClick && !indexData.NavView) {
            return {};
        }

        const navCls = this.navMode() == 'Tab' ? 'navCls' : '';
        const viewsLength =
            (isNotEmpty(indexData, ['NavView', 'sub_cmps']) &&
                indexData.NavView.sub_cmps.length) ||
            0;
        const { leftCb, headerColor } = this.getExtensionNavConfig();
        attr = {
            cls: navCls,
            navViewsLength: viewsLength,
            title: this.navTitle(),
            noSysClose: this.notShowCloseSys(),
            handleBack: leftCb && leftCb.back,
            handleClose: leftCb && leftCb.close,
            headerColor: headerColor
        };
        return attr;
    }

    renderPopNav() {
        const { NavView = {} } = this.props.indexData;
        let viewName = '';
        if (NavView.sub_cmps) {
            viewName =
                NavView.biz_data[NavView.cmp_data.currentViewName] &&
                NavView.biz_data[NavView.cmp_data.currentViewName].text;
        }
        if (ifHidePopupNav()) {
            const title = this.props.popButtonData.cmp_data.title || viewName;
            if (window.env.platform.iTalentIOS) {
                if (!this.iosTitle && title) {
                    const config = {
                        leftItem: [
                            {
                                type: 'back',
                                callback: 'popViewBack',
                                control: true
                            }
                        ],
                        titleItem: { text: title }
                    };
                    this.iosTitle = title;
                    //将导航信息存储到栈里面
                    setBaseHeaderConfig(config);
                    getEnv().configNavigation(config, ret => {
                        this.popBack();
                        getEnv().trigger({
                            name: 'iTalentIOS_pop_indexview_cancel'
                        });
                        getEnv().closePage();
                    });
                }
                return null;
            }

            if (!window.globalEventManager) {
                window.globalEventManager = {};
            }
            if (!this.props.popButtonData.cmp_data.title && viewName) {
                window.iTalentSDK.sendMessage({
                    publishEvent: 'pop_indexview_setTitle',
                    data: {
                        title: viewName
                    }
                });
            }
            return null;
        }

        const title = this.props.popButtonData.cmp_data.title || viewName;
        return (
            <Nav title={title}>
                <div role="left">
                    <span onTouchTap={this.popBack} className="staff-backward">
                        <Icon icon="m-sys-backward" />
                    </span>
                </div>
            </Nav>
        );
    }

    render() {
        if (this.props.isIndexPop) {
            return this.renderPopNav();
        }
        if (inIframe) return null;
        return (
            <BSNav {...this.navAttr()}>
                {this.navCenter()}
                {this.navRight()}
            </BSNav>
        );
    }
}

IndexNav.defaultProps = {
    indexData: {},
    popButtonData: {
        cmp_data: {}
    }
};
export default IndexNav;



// WEBPACK FOOTER //
// ./src/components/Pages/IndexNav.js